document.addEventListener("DOMContentLoaded", function(){

  const dropdownsButtons = document.querySelectorAll('.js-open-dropdown-menu');
  const body = document.querySelector('body');

  dropdownsButtons.forEach(button => {
    button.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();

      const dropdownMenu = button.nextElementSibling;
      if (dropdownMenu.classList.contains('active')) {
        dropdownMenu.classList.remove('active');
      } else {
        dropdownsButtons.forEach(btn => {
          const otherDropdownMenu = btn.nextElementSibling;
          otherDropdownMenu.classList.remove('active');
        });
        dropdownMenu.classList.add('active');
      }
    })
  })

  body.addEventListener('click', function() {
    dropdownsButtons.forEach(button => {
      const dropdownMenu = button.nextElementSibling;
      dropdownMenu.classList.remove('active');
    });
  });
})